/**
 * Parsing do CSV de resultado de análise.
 * Portado do módulo antigo (OsParaColeta/components/meta) para tornar novaOsColeta
 * independente da pasta antiga.
 */

export interface AmostraData {
  id: string
  numero: string
  nome: string
  endereco: string
  propriedade: string
  gleba: string
  mg: number
  aluminio: number
  hal: number
  sb: number
  ctc: number
  al_pct: number
  mg_pct: number
  ca_k: number
  mg_k: number
  ferro: number
  manganes: number
  bases_v: number
  percent_ca: number
  percent_k: number
  boro: number
  p: number
  p_rem: number
  ph_cacl2: number
  cobre: number
  zinco: number
  enxofre: number
  teor_argila: number
  teor_silte: number
  mo: number
}

/** Converte string numérica (aceita vírgula decimal e 'ns'/'-') em number. */
const parseRawNumber = (value: string | undefined): number => {
  if (!value) return 0

  const cleanStr = value.trim().toLowerCase()

  if (cleanStr === 'ns' || cleanStr === '-' || cleanStr === '') return 0

  const numberStr = cleanStr.replace(',', '.')
  const number = parseFloat(numberStr)

  return isNaN(number) ? 0 : number
}

/** Converte o texto do CSV (separado por ';') em uma lista de AmostraData. */
export const parseCustomCsv = (csvText: string): AmostraData[] => {
  const lines = csvText?.split(/\r\n|\n/)
  const dataLines = lines.slice(1).filter((line) => line.trim().length > 0)

  return dataLines.map((line, index) => {
    const cols = line.split(';')

    return {
      id: String(index + 1),
      numero: cols[0] || '',
      nome: cols[1] || '',
      endereco: cols[2] || '',
      propriedade: cols[3] || '',
      gleba: cols[4] || '',
      ph_cacl2: parseRawNumber(cols[5]),
      mo: parseRawNumber(cols[6]),
      p: parseRawNumber(cols[7]),
      p_rem: parseRawNumber(cols[8]),
      mg: parseRawNumber(cols[11]),
      aluminio: parseRawNumber(cols[12]),
      hal: parseRawNumber(cols[13]),
      sb: parseRawNumber(cols[14]),
      ctc: parseRawNumber(cols[15]),
      bases_v: parseRawNumber(cols[16]),
      al_pct: parseRawNumber(cols[17]),
      percent_ca: parseRawNumber(cols[18]),
      mg_pct: parseRawNumber(cols[19]),
      percent_k: parseRawNumber(cols[20]),
      ca_k: parseRawNumber(cols[22]),
      mg_k: parseRawNumber(cols[23]),
      ferro: parseRawNumber(cols[24]),
      manganes: parseRawNumber(cols[25]),
      cobre: parseRawNumber(cols[26]),
      zinco: parseRawNumber(cols[27]),
      boro: parseRawNumber(cols[28]),
      enxofre: parseRawNumber(cols[29]),
      teor_argila: parseRawNumber(cols[30]),
      teor_silte: parseRawNumber(cols[31]),
    }
  })
}
